/**
 * 生成当前搭配数据（outfit）- 支持多模板
 */
export function buildOutfit(
  mainTemplate: { config: any; id?: string; spineVersion?: number },
  relatedTemplates: { config: any; id: string; spineVersion?: number }[],
  selectedSkins: string[],
  selectedToningColors: Record<string, string>,
  currentAnimation?: string,
): any | null {
  if (!mainTemplate.config) return null;

  const allTemplates = [
    {
      config: mainTemplate.config,
      id: mainTemplate.id || mainTemplate.config.id || "",
      isMain: true,
      spineVersion: mainTemplate.spineVersion,
    },
    ...relatedTemplates.map((rel) => ({
      config: rel.config,
      id: rel.id,
      isMain: false,
      spineVersion: rel.spineVersion,
    })),
  ];

  const data = allTemplates
    .map((template) => {
      const skus = template.config.skus || {};
      const skinNameToSku = new Map<string, any>();
      for (const [skuId, sku] of Object.entries(skus)) {
        const skuData = sku as any;
        if (skuData.skinName) {
          skinNameToSku.set(skuData.skinName, { id: skuId, ...skuData });
        }
      }

      const skuIds: string[] = [];
      const boundToningIds = new Set<string>();

      // 只找出属于该模板的选中皮肤
      for (const skinName of selectedSkins) {
        const sku = skinNameToSku.get(skinName);
        if (sku) {
          skuIds.push(sku.id);
          if (sku.toningIds) {
            sku.toningIds.forEach((tid: string) => boundToningIds.add(tid));
          }
        }
      }

      // 只导出与当前模板选中 SKU 关联的染色
      const tonings: Record<string, string> = {};
      for (const [toningId, colorSetId] of Object.entries(selectedToningColors)) {
        if (boundToningIds.has(toningId)) {
          tonings[toningId] = colorSetId;
        }
      }

      // 只有在该模板有选中 SKU 或染色时才导出
      if (skuIds.length === 0 && Object.keys(tonings).length === 0) {
        return null;
      }

      const templateData: any = {
        templateId: template.id,
        skus: skuIds,
        tonings,
      };

      if (
        template.spineVersion != null &&
        Number.isFinite(template.spineVersion)
      ) {
        templateData.spineVersion = template.spineVersion;
      }

      // 动画通常只跟主模板关联（或者以后可能扩展到其他模板）
      if (template.isMain && currentAnimation) {
        templateData.animation = currentAnimation;
      }

      return templateData;
    })
    .filter((d) => d !== null);

  return { data };
}

